/**
 * Copia texto para a área de transferência.
 *
 * Tenta a Clipboard API e, quando ela não existe (contexto inseguro, iframe sem permissão, navegador antigo)
 * ou recusa a escrita, cai no fallback de selecionar um `textarea` e chamar `document.execCommand('copy')`.
 * Deve ser chamada direto no handler do clique: fora do gesto do utilizador os navegadores bloqueiam a cópia.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  if (!text) return false;

  const clipboard = typeof navigator !== 'undefined' ? navigator.clipboard : undefined;
  if (clipboard?.writeText) {
    try {
      await clipboard.writeText(text);
      return true;
    } catch {
      // segue para o fallback
    }
  }

  return copyWithExecCommand(text);
}

function copyWithExecCommand(text: string): boolean {
  if (typeof document === 'undefined' || typeof document.execCommand !== 'function') return false;

  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.top = '0';
  textarea.style.left = '0';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  textarea.setSelectionRange(0, text.length);

  let copied = false;
  try {
    copied = document.execCommand('copy');
  } catch {
    copied = false;
  } finally {
    document.body.removeChild(textarea);
  }
  return copied;
}
